module.exports = __webpack_public_path__ + "static/img/expo.c5f6a24e.png";